import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CompanyService } from 'src/app/services/management/company.service';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-implement-quotation',
  templateUrl: './implement-quotation.component.html',
  styleUrls: ['./implement-quotation.component.scss'],
  standalone: false
})
export class ImplementQuotationComponent implements OnInit {

  companyId: number = 0;
  companyName: string = '';
  isOpened: string | undefined = undefined;
  nameWindow: string = 'Implementar Cotizaciones';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = "";

  listCompany: any[] = [];

  constructor(private companyService: CompanyService,
    private quotationService: QuotationService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    } else {
      localStorage.clear();
    }
  }

  createQuotationsFromCostCenterPrices() {
    if (this.companyId != 0) {
      Swal.fire({
        title: 'Atención',
        text: '¿Realmente desea implementar cotizaciones para esta compañía?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await firstValueFrom(this.quotationService.createQuotationsFromCostCenterPrices(this.companyId));
          if (response) {
            this.toastHandlerService.showToast(
              'success',
              'El proceso terminó exitosamente.'
            );
          }
        }
      });
    } else {
      this.toastHandlerService.showToast(
        'error',
        `La compañía seleccionada no es válida.`,
        'Error'
      );
    }
  }

  async getCompaniesForSelect() {
    try {
      const response = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
      this.listCompany = response;
    } catch (error) {
      console.error('Error obtener la lista de compañias.', error);
    }
  }

  getCompanyId(companyId: number | null) {
    if (!companyId) {
      this.companyId = 0;
      this.companyName = '';
      return;
    }

    const company = this.listCompany?.find(x => x.value === companyId);
    this.companyId = company?.value ?? 0;
  }

  async getPermission() {
    const url = this.router.url as string;
    this.url = url.substring(1);
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`,
          'Error'
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getCompaniesForSelect();
  }

  revertImplementQuotation() {
    if (this.companyId != 0) {
      Swal.fire({
        title: 'Atención',
        text: '¿Realmente desea revertir el proceso de implemntarión de cotizaciones para esta compañía?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await firstValueFrom(this.quotationService.revertImplementQuotation(this.companyId));
          if (response) {
            this.toastHandlerService.showToast(
              'success',
              'El proceso terminó exitosamente.'
            );
          }
        }
      });
    } else {
      this.toastHandlerService.showToast(
        'error',
        `La compañía seleccionada no es válida.`,
        'Error'
      );
    }
  }
}
